export const PaymentGatewayType = {
  Wallet: "wallet",
  Stars: "stars",
  Stripe: "stripe",
} as const;

export type PaymentGatewayType =
  (typeof PaymentGatewayType)[keyof typeof PaymentGatewayType];

export const PaymentMethodType = {
  Usd: "usd",
  Stars: "stars",
} as const;

export type PaymentMethodType =
  (typeof PaymentMethodType)[keyof typeof PaymentMethodType];
